<template>
  <nav class="tw-flex tw-items-center tw-gap-1.5" :aria-label="$t('Enrollment progress')">
    <TooltipProvider v-for="(entry, index) in bar" :key="entry.barGroupKey" :delay-duration="150">
      <Tooltip>
        <TooltipTrigger as-child>
          <Button
            variant="unstyled"
            size="none"
            :disabled="!isClickable(index)"
            :aria-label="$t(entry.barTitle)"
            :aria-current="index === currentBarIndex ? 'step' : undefined"
            :aria-disabled="!isClickable(index)"
            :tabindex="isClickable(index) ? 0 : -1"
            :class="[
              'tw-h-1.5 tw-w-6 sm:tw-w-9 md:tw-w-11 lg:tw-w-12 tw-rounded-full tw-transition-colors tw-p-0 tw-min-w-0',
              index <= currentBarIndex ? 'tw-bg-secondary' : 'tw-bg-secondary/20',
              isClickable(index) ? 'tw-cursor-pointer' : 'tw-cursor-default'
            ]"
            @click="onSegmentClick(index)"
          />
        </TooltipTrigger>
        <TooltipContent>{{ $t(entry.barTitle) }}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
    <span
      class="tw-ml-1 tw-inline-flex tw-items-center tw-justify-center tw-h-5 tw-min-w-[2rem] tw-px-1.5 tw-rounded-md tw-bg-secondary tw-text-secondary-foreground tw-text-[11px] tw-font-semibold tw-leading-none"
      aria-hidden="true"
    >
      {{ currentBarIndex + 1 }}/{{ bar.length }}
    </span>
    <span class="tw-sr-only">
      {{ $t("Step {current} of {total}", { current: currentBarIndex + 1, total: bar.length }) }}
    </span>
  </nav>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import { useStepperBar } from "@/modules/enrollment-new/pages/enrollment-flow/composables/useStepperBar"
import { Button } from "@/components/ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"

const { t: $t } = useI18n()
const $router = useRouter()

const { bar, currentBarIndex, isClickable, routeForBar } = useStepperBar()

function onSegmentClick(index: number): void {
  if (!isClickable(index)) return
  $router.push(routeForBar(index))
}
</script>
